import * as React from 'react';

export default (event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (event.key === 'e' || event.key === '-') {
        event.preventDefault();
    }
};

export const removeExpotential = (event: React.ClipboardEvent<HTMLInputElement>, value: string): void => {
    if (value.includes('e')) {
        event.preventDefault();
    }
};



// WEBPACK FOOTER //
// ./src/view/preventExpotential.ts